import { useEffect } from "react";
import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";

/**
 * Custom hook to unlock ads that haven't been updated in the last 30 minutes.
 * @param {Array} usedAds - Array of ad objects to unlock.
 */
export function useCleanRealtimeAdLockByDate({ selectedAds }) {
  useEffect(() => {
    if (selectedAds.length > 0) {
      selectedAds.forEach((ad) => {
        // Check if the ad's updatedDate is more than 30 minutes ago
        const updatedDate = new Date(ad.updatedDate);
        const now = new Date();
        const minutesTimeToCheck = 30;
        const timeToCheckInMillis = minutesTimeToCheck * 60 * 1000;
        const isOlderThanTimeToCheck = now - updatedDate > timeToCheckInMillis;

        if (isOlderThanTimeToCheck) {
          ActionsAdAssistant.updateAd(
            {
              isLocked: false,
              lockedBy: null,
              lockedUserId: null
            },
            ad.id
          );
        }
      });
    }
  }, [selectedAds]);
}
